import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-500/15 text-accent-400 border border-accent-500/20 mb-4">
            深度策划
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-50">
            焦点专题
          </h2>
          <p className="mt-3 text-sm text-foreground-400 max-w-lg mx-auto">
            编辑精选的深度内容专题，带你全面了解热门事件
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {carouselItems.map((item) => (
            <article
              key={item.id}
              className="group relative rounded-xl overflow-hidden bg-background-50 border border-background-200/50 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/10 to-transparent" />
                <span className="absolute top-3 left-3 px-2 py-0.5 text-[11px] font-medium rounded bg-primary-500/80 text-foreground-50 whitespace-nowrap backdrop-blur-sm">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors mb-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}